import { useEffect } from 'react';

/**
 * `useScrollToTop` scrolls the page to the top when the provided state changes.
 * @param state - Can be any type or value.
 */
const useScrollToTop = (state: unknown) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [state]);
};

export default useScrollToTop;
